import { render, staticRenderFns } from "./GravatarImg.vue?vue&type=template&id=3bad5ea5&scoped=true&"
import script from "./GravatarImg.vue?vue&type=script&lang=ts&"
export * from "./GravatarImg.vue?vue&type=script&lang=ts&"
import style0 from "./GravatarImg.vue?vue&type=style&index=0&id=3bad5ea5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad5ea5",
  null
  
)

export default component.exports